import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  style: {
                        width: `80px`,
                    },
  class: /*#__PURE__*/_normalizeClass(`mc`)
}
const _hoisted_4 = ["src", "height", "width"]
const _hoisted_5 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(``)
}
const _hoisted_6 = { class: "rad8" }
const _hoisted_7 = ["src", "height", "width"]
const _hoisted_8 = {
  key: 2,
  class: "posAb",
  style: {"top":"-6px","right":"-5px"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["src", "height", "width"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "ファイルを削除しました", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "ml5"
}
const _hoisted_19 = {
  key: 0,
  class: "ddgrey fs14 fw600"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = {
  key: 1,
  class: "dgrey fs12"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "ファイルを削除しました", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 2,
  class: "posAb",
  style: {"top":"-6px","right":"-5px"}
}
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 3,
  class: "clear"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.file)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "posRe",
        onMouseover: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.mouseover && _ctx.mouseover(...args))),
        onMouseleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.mouseleave && _ctx.mouseleave(...args)))
      }, [
        (_ctx.showOnlyIcon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.file.is_image_file)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _withDirectives(_createElementVNode("img", {
                        src: _ctx.parentId ? `${_ctx.file.image_url}&parent_room_id=${_ctx.parentId}` : _ctx.file.image_url,
                        height: _ctx.width || 80,
                        width: _ctx.width || 80,
                        class: _normalizeClass(`imageFit`),
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickImage && _ctx.clickImage(...args)))
                      }, null, 8, _hoisted_4), [
                        [
                          _directive_tooltip,
                          `${_ctx.file.original_filename}(${_ctx.file.file_size})`,
                          void 0,
                          { bottom: true }
                        ]
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/file_with_clip.png`),
                        height: _ctx.width || 60,
                        width: _ctx.width || 60,
                        class: ""
                      }, null, 8, _hoisted_7)
                    ])
                  ])),
              (_ctx.showDeleteButton && _ctx.showDelete && _ctx.file.can_delete)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                      width: "20",
                      height: "20",
                      class: "pointer",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteAttachment(_ctx.file)))
                    }, null, 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.file.is_image_file)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(` fr ml5 ofh`),
                    style: _normalizeStyle({
                    width: _ctx.isWideType ? `270px` : ``,
                })
                  }, [
                    (!_ctx.file.did_delete && !_ctx.didDelete)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", {
                            style: _normalizeStyle({
                            border: _ctx.type != `form` ? `1px solid #ddd;` : ``,
                            width: _ctx.isWideType ? `80px` : `30px`,
                        }),
                            class: _normalizeClass(`rad4 ofh ${_ctx.isChatType || _ctx.type == `owner_modal` ? (!_ctx.isMe ? `fl` : `fr`) : ``}`)
                          }, [
                            _withDirectives(_createElementVNode("img", {
                              src: _ctx.parentId ? `${_ctx.file.image_url}&parent_room_id=${_ctx.parentId}` : _ctx.file.image_url,
                              height: _ctx.isWideType ? 80 : 30,
                              width: _ctx.isWideType ? 80 : 30,
                              class: _normalizeClass(`${_ctx.isChatType ? `zoom` : ``} imageFit ${_ctx.isWideType ? `fl` : ``}`),
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickImage && _ctx.clickImage(...args)))
                            }, null, 10, _hoisted_12), [
                              [
                                _directive_tooltip,
                                `${_ctx.file.original_filename}(${_ctx.file.file_size})`,
                                void 0,
                                { bottom: true }
                              ]
                            ])
                          ], 6),
                          ([`wide`, `owner_modal`].includes(_ctx.type))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: {"line-height":"80px"},
                                class: _normalizeClass(`${_ctx.type == `wide` && !_ctx.isMe ? `fl` : `fr`} mr8`)
                              }, [
                                _createElementVNode("span", {
                                  class: "fw600 fs12 pointer skyblue mr10",
                                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
                                }, "ダウンロード"),
                                _createElementVNode("span", {
                                  class: "fw600 fs12 pointer skyblue",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteAttachment(_ctx.file)))
                                }, "削除")
                              ], 2))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                  ], 4))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(`${_ctx.isChatType ? `fr` : ``} ml5 mb8 ${_ctx.isWideType ? `mb8` : ``}`),
                    style: _normalizeStyle({
                    width: _ctx.isWideType ? `270px` : ``,
                })
                  }, [
                    (_ctx.isWideType)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rad8",
                          style: _normalizeStyle({
                        border: _ctx.isChatType ? `1px solid #ddd;` : ``,
                        height: `60px`,
                        padding: `8px 4px`,
                    })
                        }, [
                          (!_ctx.file.did_delete && !_ctx.didDelete)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/file_with_clip.png`),
                                  height: "40",
                                  width: "40",
                                  class: "fl ml5"
                                }, null, 8, _hoisted_17),
                                (!_ctx.hideName || !_ctx.hideDownloadLink)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      (!_ctx.hideName)
                                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_19, [
                                            _createTextVNode(_toDisplayString(_ctx.truncate(_ctx.file?.original_filename || ``, 30)), 1)
                                          ])), [
                                            [_directive_tooltip, _ctx.file?.original_filename?.length > 30 ? `${_ctx.file.original_filename}` : null]
                                          ])
                                        : _createCommentVNode("", true),
                                      _hoisted_20,
                                      (!_ctx.hideName)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.file.file_size) + " " + _toDisplayString(_ctx.file.extname.toUpperCase()), 1))
                                        : _createCommentVNode("", true),
                                      (!_ctx.hideDownloadLink)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 2,
                                            class: "fw600 fs12 pointer skyblue mr10",
                                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
                                          }, "ダウンロード"))
                                        : _createCommentVNode("", true),
                                      ([`wide`, `owner_modal`].includes(_ctx.type))
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 3,
                                            class: "fw600 fs12 pointer skyblue",
                                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteAttachment(_ctx.file)))
                                          }, "削除"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                        ], 4))
                      : _withDirectives((_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.$getAssetImageUrl(`/assets/icons/file_with_clip.png`),
                          height: "30",
                          width: "30"
                        }, null, 8, _hoisted_25)), [
                          [
                            _directive_tooltip,
                            `${_ctx.file.original_filename}(${_ctx.file.file_size})`,
                            void 0,
                            { bottom: true }
                          ]
                        ])
                  ], 6)),
              (_ctx.showDeleteButton && _ctx.showDelete && _ctx.file.can_delete)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                      width: "20",
                      height: "20",
                      class: "pointer",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteAttachment(_ctx.file)))
                    }, null, 8, _hoisted_27)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isWideType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                : _createCommentVNode("", true)
            ]))
      ], 32))
    : _createCommentVNode("", true)
}